import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useLang, lp } from "@/lib/i18n";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Maison from "@/pages/Maison";
import Crisopea from "@/pages/Crisopea";
import CrisopeaProduct from "@/pages/CrisopeaProduct";
import Domino from "@/pages/Domino";
import DominoProduct from "@/pages/DominoProduct";
import Maroquinerie from "@/pages/Maroquinerie";
import MaroquinerieProduct from "@/pages/MaroquinerieProduct";
import Revendeurs from "@/pages/Revendeurs";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NewsletterConfirm from "@/pages/NewsletterConfirm";
import NotFound from "@/pages/NotFound";
import Panier from "@/pages/Panier";
import { CartProvider } from "@/lib/cart";

// L'ancienne collection DAMES est abandonnée : ses URL renvoient vers CRISOPEA.
const DamesRedirect = () => {
  const lang = useLang();
  return <Navigate to={lp(lang, "/crisopea")} replace />;
};

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Un seul arbre de pages, monté sur "/" (FR) et sur "/en" (EN).
const pages = (
  <>
    <Route index element={<Home />} />
    <Route path="la-maison" element={<Maison />} />
    <Route path="crisopea" element={<Crisopea />} />
    <Route path="crisopea/:slug" element={<CrisopeaProduct />} />
    <Route path="dames" element={<DamesRedirect />} />
    <Route path="dames/*" element={<DamesRedirect />} />
    <Route path="domino" element={<Domino />} />
    <Route path="domino/:serie/:roman" element={<DominoProduct />} />
    <Route path="maroquinerie" element={<Maroquinerie />} />
    <Route path="maroquinerie/:slug" element={<MaroquinerieProduct />} />
    <Route path="revendeurs" element={<Revendeurs />} />
    <Route path="contact" element={<Contact />} />
    <Route path="panier" element={<Panier />} />
    <Route path="confirmation-newsletter" element={<NewsletterConfirm />} />
    <Route path="mentions-legales" element={<Legal page="mentions" />} />
    <Route path="cgv" element={<Legal page="cgv" />} />
    <Route path="confidentialite" element={<Legal page="confidentialite" />} />
    <Route path="retours" element={<Legal page="retours" />} />
    <Route path="*" element={<NotFound />} />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <ScrollTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/">{pages}</Route>
            <Route path="/en">{pages}</Route>
          </Route>
        </Routes>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
